import Tooltip from '@amzn/meridian/tooltip';
import React from 'react';

interface WrapperProps {
  tooltip?: string | false;
  children: React.ReactElement | React.ReactElement[];
}

const Wrapper: React.FC<WrapperProps> = ({
  tooltip,
  children,
}: WrapperProps) => {
  // This wrapper is intended for interactive components.
  return tooltip ? (
    <Tooltip position='top' title={tooltip}>
      <span>{children}</span>
    </Tooltip>
  ) : (
    <>{children}</>
  );
};

export default Wrapper;
